import { createStore } from 'satcheljs';
var BrandsSubscriptionsDataStore = {
    subscriptions: [],
    unsubscribedSubscriptions: [],
};
var getStore = createStore('brandsSubscriptions', BrandsSubscriptionsDataStore);
export default getStore;
//# sourceMappingURL=store.js.map